module.exports = __webpack_public_path__ + "static/media/flower3_big.061cf57f.png";